export default {
    //R
    account:{
        /*=== add-label.vue ====*/
        trading_account_label: "La etiqueta se agregó correctamente a su Cuenta de trading.",
        ok: "OK",
        add_account_label: "Agregar Etiqueta de cuenta",
        trading_account: "Cuenta de trading",
        select_trading_id: "Seleccionar ID de trading",
        label: "Etiqueta",
        alpha_numeric_characters : "Asigne una etiqueta a su cuenta: (Clave alfanumérica de hasta 15 caracteres)",
        apply: "Aplicar",
        cancel: "Cancelar",
        
        /*=== change-acct-leverage.vue ====*/
        request_change_laverage: "Recibimos su solicitud para cambiar el apalancamiento de su ID de trading",
        from :"De",
        to :"Para",
        confirm_mail_id:"Para confirmar, haga clic en el enlace de confirmación enviado a su dirección de correo electrónico registrada.",
        leverage_successfully_change:"Solicitud de cambio de apalancamiento procesada con éxito",
        change_account_leverage:"Cambiar apalancamiento de la cuenta",
        select_trading_account :"Seleccionar cuenta de trading",
        existing_leverage :"Apalancamiento existente",
        new_leverage :"Nuevo apalancamiento",
        select_new_leverage :"Seleccionar nuevo apalancamiento",
        change_leverage:"Cambiar apalancamiento",
        account_leverage_reduced :"Si se reduce el apalancamiento de la cuenta desde el apalancamiento actual, aumentará el margen utilizado en sus operaciones abiertas (si las hay).",
        
        /*=== create-account.vue ====*/
        mandatory_complete_KYC:"Es obligatorio completar el KYC antes de crear más de una cuenta en vivo.",
        submit_proof_address:"Envíe un comprobante de domicilio usando un ticket de asistencia ",
        click_here:"Haga clic aquí",
        email_to: "o envíe un correo electrónico a",
        contactus_aaafx_com :"contactus{'@'}aaafx.com",
        following_address_Proofs: "Se aceptan los siguientes comprobantes de domicilio:",
        utility_bill: "Factura de servicios públicos",
        bank_statement: "Estado de cuenta",
        government_issued:"Documento tributario emitido por el gobierno",
        note:"Nota",
        proof_of_address:"El comprobante de domicilio no debe tener una antigüedad mayor a 4 meses.",
        account :"Cuenta",
        select_platform:"Seleccione Plataforma",
        select_account_type:"Seleccione Tipo de cuenta",
        connect_your_account:"¿Quiere vincular su cuenta a ZuluTrade?",
        select_leverage:"Seleccione Apalancamiento",
        select_account_base_currency:"Seleccione la divisa base de la cuenta",
        select_currency:"Seleccione Divisa",
        Password:"Contraseña",
        minimum_password_length5:"La longitud mínima de la contraseña es de 5 caracteres y debe contener al menos 1 letra minúscula, 1 letra mayúscula, 1 número y 1 carácter especial.",
        minimum_password_length8:"La longitud mínima de la contraseña es de 8 caracteres y debe contener al menos 1 letra minúscula, 1 letra mayúscula, 1 número y 1 carácter especial.",
        spcl_characters:"# de caracteres",
        lowercase_letter:"Letra minúscula",
        capital_letter:"Letra mayúscula",
        number: "Número",
        special_character:"Carácter especial",
        confirm_password :"Confirmar contraseña",
        trade_With_virtual_funds:"Opere con fondos virtuales",
        test_strategies:"Pruebe estrategias de forma gratuita",
        risk_free_trading:"Trading libre de riesgos",
        live_market_feed: "Información en directo sobre el mercado",
        liquidity_from_top :"Liquidez de los principales proveedores de liquidez (LP)",
        effective_trading:"Herramientas de trading efectivas",
        instant_execution:"Ejecución al instante",
        low_commissions:"Comisiones y spreads bajos",
        create_new:"Crear nuevo",
        
        /*=== enable-2fa.vue ====*/
        enable_2fa: "Activar la autenticación de 2 factores",
        click_to_enable: "Haga clic para activar",
        
        /*=== internal-transfer.vue ====*/
        received_your_request:"Recibimos su solicitud para transferir",
        from_trading_account:"desde la cuenta de trading",
        to_confirm:"Para confirmar, haga clic en el enlace de confirmación enviado a su dirección de correo electrónico registrada.",
        internal_transfer_request:"Su solicitud de transferencia interna desde la cuenta",
        for_amount:"por la cantidad",
        to_account:"a la cuenta",
        was_succesfull :"fue exitosa con una cantidad de",
        internal_transfer: "Transferencia interna",
        transfer_From: "Transferir desde",
        transfer_to:"Transferir a",
        balance: "Saldo",
        enter_amount: "Ingresar monto",
        USE_MAX:"USAR MÁX.",
        proceed:"Continuar",
        Internal_Transfer_ZIP:"La transferencia interna no está disponible para la cuenta ZTP.",
        In_case_of_internal_transfer:"Nota: En caso de transferencia entre cuentas con diferentes divisas base, la cantidad que se transfiera se hará según los precios prevalecientes del mercado.",
        
        /*=== manage-account.vue ====*/
        attention :"Atención: Está a un paso de solicitar la eliminación de la ID de trading",
        note_after_requesting:"Note: Tras hacer su solicitud, su cuenta se eliminará de los registros y no podrá restablecerla.",
        after_clicking:"Después de hacer clic en confirmar, recibirá un enlace de confirmación en su dirección de correo electrónico registrada para eliminar su cuenta de trading",
        currency: "Divisa",
        Account_Type: "Tipo de cuenta",
        Account_Label: "Etiqueta de cuenta",
        Bonus: "Bono",
        Leverage: "Apalancamiento",
        Equity: "Capital",
        Create_Demo_Account: "Crear Cuenta Demo",
        Create_Live_Account :"Crear cuenta en vivo",
        internal_transfer_CAP:"TRANSFERENCIA INTERNA",
        web_trading:"TRADING WEB",
        add_account_label_CAP:"AGREGAR ETIQUETA DE CUENTA",
        change_laverage:"CAMBIAR APALANCAMIENTO",
        delete_account:"Eliminar cuenta",
        reset_trading_password:"RESTABLECER CONTRASEÑA DE TRADING",
        
        verifying_your_request: "Verificando su solicitud…",
        success: "ÉXITO",
        error: "ERROR",
        
        /*=== operations-verify.vue ====*/
        we_have_received_your_request :"Recibimos su solicitud para restablecer la contraseña de Inversor. Para confirmar, haga clic en el enlace de confirmación enviado a su dirección de correo electrónico registrada.",
        change_investor_password:"Se cambió la contraseña de Inversor con éxito.",
        reset_investor_password:"Restablecer contraseña de Inversor",
        investor_password:"Contraseña de Inversor",
        master_password:"Contraseña maestra",
        trading_iD: "ID de trading",
        enter_new_password:"Introducir nueva contraseña",
        confirm_new_password :"Confirmar nueva contraseña",
        password_must_contain:"Su contraseña debe tener entre 6 y 10 caracteres, al menos 1 número, 1 letra mayúscula y 1 carácter especial (!@$%*)",
        change_Password:"Cambiar contraseña",
        
        /*=== reset-investor-pass.vue ====*/
        reset_master_password:"Restablecer contraseña maestra",
        click_reset:"Haga clic aquí para restablecer",
        password_caption:"La contraseña de Inversor es la contraseña de solo lectura, que no permite al usuario realizar operaciones. Si inicia sesión usando la contraseña maestra, obtiene acceso completo y derechos de trading en la cuenta.",
    },
    auth: {
        /*=== corporate.vue ====*/
        corporate: "Empresa",
        account_type: "Tipo de cuenta",
        select_account_type: "Seleccione el tipo de cuenta",
        individual: "Individual",
        name_of_company: "Nombre de la empresa",
        country_of_company: "País de la empresa",
        select_company_country: "Seleccione el país de la empresa",
        registration: "Inscripción",
        email_company: "Correo electrónico de la empresa",
        Password: "Contraseña",
        min_password_length8: "La longitud mínima de la contraseña es de 8 caracteres y debe contener al menos 1 letra minúscula, 1 mayúscula, 1 número y 1 carácter especial.",
        spcl_characters: "# de caracteres",
        lowercase_letter: "Letra minúscula",
        capital_letter: "Letra mayúscula",
        number: "Número",
        special_character: "Carácter especial",
        confirm_password: "Confirmar contraseña",
        Phone_Number: "Número de teléfono",
        have_read: "He leído, entendido y aceptado los",
        terms_conditions: "Términos y Condiciones",
        accept_terms_conditions: "Acepte los términos y condiciones",
        given_your_residency: "Teniendo en cuenta su residencia, será contratado por Triple A Experts Investment Services (GR), una empresa regulada por HCMC. Puede consultar las medidas de protección disponibles y los Términos y condiciones en nuestro sitio web. Al hacer clic ",
        continue: "en continuar",
        triple_investment_services: "acepta la apertura de su cuenta con Triple A Experts Investment Services (GR).",
        register: "REGISTRARSE",
        already_have_account: "¿Ya tiene una cuenta?",
        login: "Iniciar sesión",
        /*=== forgot-password.vue ====*/
        confirmation_link: "Se envió un enlace de confirmación a su dirección de correo electrónico registrada. Haga clic en el enlace para restablecer su contraseña de inicio de sesión.",
        ok: "OK",
        this_email_address: "Esta dirección de correo electrónico no está registrada con nosotros.",
        click_here: "Haga clic aquí",
        create_account_now: "para crear una cuenta ahora",
        forgot_password: "Olvidé mi contraseña",
        email_address: "Dirección de correo electrónico",
        submit: "Enviar",
        dont_have_account: "¿No tiene una cuenta?",
        create_account_now_CAP: "¡CREE UNA CUENTA AHORA!",
        /*=== login.vue ====*/
        client_login: "Inicio de sesión de clientes",
        remember_me: "Recordarme",
        two_step_verification: "Verificación en dos pasos",
        google_authenticator: "Introduzca la contraseña de un solo uso que se muestra en la app Google Authenticator.",
        google_auth_code: "Código de Google Authenticator",
        /*=== register.vue ====*/
        sent_an_OTP: "Enviamos una OTP a",
        complete_your_registration: "Introdúzcalo para verificar y completar su registro.",
        otp: "OTP",
        Register_heading: "Registro",
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo electrónico",
        country: "País",
        select_residence_country: "Seleccionar país de residencia",
        privacy_policy: "Política de Privacidad",
        accept_privacy_policy: "Acepte la Política de Privacidad",
        experts_investment_services: "Teniendo en cuenta su residencia, será contratado por Triple A Experts Investment Services (GR), una empresa regulada por HCMC. Puede consultar las medidas de protección disponibles y los Términos y condiciones en nuestro sitio web. Al hacer clic ",
        opening_your_account: "acepta abrir su cuenta con Triple A Experts Investment Services (GR).",
        /*=== reset-password.vue ====*/
        login_password_change: "Su contraseña de inicio de sesión se modificó correctamente.",
        reset_password: "Restablecer contraseña",
        reset: "Restablecer",
    },
    //H
    copy_trading: {
        copy_trading: "Copy Trading",
        copy_trading_header: "Consiga ganancias copiando automáticamente las operaciones del gestor de la estrategia",
        leading_traders: "COPIAR AUTOMÁTICAMENTE A LOS TRADERS LÍDERES",
        diversified_trading: "PORTAFOLIO DE OPERACIONES DIVERSIFICADO",
        monitor_profit: "MONITOREAR Y GANAR",
        copy_traders: "¿CÓMO COPIAR LAS OPERACIONES?",
        one: "1.",
        one_header: "Abra una Cuenta real y haga un depósito.",
        two: "2.",
        two_header: "Seleccione un Gestor de Estrategia.",
        three: "3.",
        three_header: "Acepte los Términos y condiciones.",
        four: "4.",
        four_header: "Proporciónenos su conformidad.",
        five: "5.",
        five_header: "Obtenga ganancias copiando operaciones.",
        order_processing: "GESTIÓN RÁPIDA DE ÓRDENES",
        end_result: "CONTROL DEL RESULTADO FINAL",
        trading_skills: "PERFECCIONE SUS HABILIDADES DE TRADING",
        start: "Iniciar"
    },
    downloads: {
        mt_four_desktop: "MT4 Desktop",
        mt_four_android: "MT4 Android",
        mt_four_ios: "MT4 iOS",
        mt_four_web_trader: "MT4 Web Trader",
        mt_five_desktop: "MT5 Desktop",
        mt_five_android: "MT5 Android",
        mt_five_ios: "MT5 iOS",
        mt_five_web_trader: "MT5 Web Trader",
        act_trader_desktop: "Act Trader Desktop",
        act_trader_android: "Act Trader Android",
        act_trader_ios: "Act Trader iOS",
        act_web_trader: "Act Web Trader"
    },
    tools_index: {
        avail_vps: "¿Seguro que quiere utilizar VPS?",
        package: "¿Paquete?",
        yes: "Sí",
        no: "NO",
        downloads: "Descargas",
        copy_trading: "Copy Trading",
        vps: "VPS"
    },
    vps: {
        vps_plans: "Planes VPS",
        bronze: "BRONCE",
        monthly_subscription_twenty_five: "Suscripción mensual de 25 USD",
        free_deposit_five_thousand: "Es gratis con un depósito igual o superior a 5 000 USD.",
        compatible_mt_four_five_act: "Compatible con MT4, MT5 y Act",
        free_twenty_five_gb_disk_space_ram_vcpu: "25 GB de espacio libre en disco | 1300 MB de RAM | 1 vCPU",
        windows_linux_support: "Windows 8/10/12, compatible con Linux",
        avail_now: "Disponible ahora",
        silver: "PLATA",
        monthly_subscription_fourty_five: "Suscripción mensual de 45 USD",
        free_on_deposit_ten_thousand: "Es gratis con un depósito igual o superior a 10 000 USD.",
        free_fifty_gb_disk_space_ram_vcpu: "50 GB de espacio libre en disco | 2700 MB de RAM | 2 vCPU",
        gold: "ORO",
        monthly_subscription_eighty: "Suscripción mensual de 80 USD",
        free_on_deposit_fifteen_thousand: "Es gratis con un depósito igual o superior a 15 000 USD.",
        free_seventy_five_gb_disk_space_ram_vcpu: "75 GB de espacio libre en disco | 5120 MB de RAM | 3 vCPU"
    },
    ticket_details: {
        cancel_withdrawal_request: "Cancelar solicitud de retiro",
        cancel_your_withdrawal_request: "¿Seguro que quiere cancelar su Solicitud de retiro?",
        process_request: "Solicitud de Proceso",
        open_tickets: "Entradas abiertas",
        back: "Volver",
        ticket_number: "Número de entrada:",
        created: "Creado:",
        reason: "Motivo:"
    },
    bonus: {
        request_to_avail_bonus: "Su solicitud para hacer uso del bono de",
        trading_id: "para el ID de trading",
        click_confirmation_link: "ha sido recibida. Para confirmar, haga clic en el enlace de confirmación enviado a su ID de correo electrónico registrado.",
        request_to_remove_bonus: "Su solicitud para eliminar el bono de",
        bonus_amount: "Su monto del bono de",
        successfully_removed_account: "se eliminó con éxito de la cuenta id",
        ok: "OK",
        request_to_add_bonus: "Su solicitud para agregar el bono de",
        successfully: "se realizó con éxito.",
        bonus: "BONO",
        select_trading_id: "Seleccionar ID de trading",
        use_max: "Usar máximo",
        account_type: "Tipo de cuenta",
        equity: "Capital",
        leverage: "Apalancamiento",
        currency: "Divisa",
        current_bonus: "Bono Actual",
        allowed_bonus: "Bono Permitido",
        remove: "Eliminar",
        account_first: "Seleccione primero una cuenta",
        bonus_amount_base_currency: "Nota: Ingrese el monto del bono en la divisa base.",
        point_one: "1. Nuestra oferta de bono del 100% está disponible para todos los clientes que realicen un depósito mínimo de 100 USD y con un apalancamiento de cuenta de hasta 1:200. El bono máximo permitido es de 40 000 USD por cliente.",
        point_two: "2. Los ingresos obtenidos de las operaciones con nuestro bono serán de su propiedad. Los bonos permanecerán intactos si retira sus ganancias.",
        point_three: "3. Los bonos aumentan el margen disponible en la cuenta. Sin embargo, sus pérdidas no pueden ser cubiertas con bonos. Si las pérdidas totales en sus operaciones superan su saldo disponible, el sistema liquidará automáticamente las posiciones en su cuenta de trading sin ninguna notificación previa.",
        point_four: "4. El importe proporcional del bono se deduciría de su cuenta si retira los fondos propios.",
        read_understood_accepted: "He leído, entendido y aceptado los",
        aaafx_bonus_policy: "Política de Bonificaciones AAAFx.",
        accept_aaafx_bonus_policy: "Acepte la Política de bonificaciones AAAFx",
        proceed: "Proceder",
        no_bonus_available_account: "No hay bonos disponibles para esta cuenta"
    },
    refer_earn: {
        bonus: "BONO",
        refer_earn: "REFIERA Y GANE",
        refer_friend: "Refiera a un amigo",
        earn_dollar_twenty_five: "Gane 25 USD",
        per_friend: "por amigo",
        why_refer_someone_to_us: "¿Por qué recomendarnos con alguien?",
        refer_someone_point_one: "1. Usted y su amigo podrán disfrutar del bono por recomendación.",
        refer_someone_point_two: "2. Un procedimiento sencillo y rápido",
        refer_someone_point_three: "3. Ambos se benefician de nuestras condiciones de trading favorables.",
        refer_someone_point_four: "4. Las ganancias de las referencias son ilimitadas.",
        what_need_to_do: "Esto es lo que debe hacer:",
        what_need_to_do_point_one: "1. Comparta su enlace de referencia con sus asociados.",
        what_need_to_do_point_two: "2. Sus referidos se registran con su enlace y comienzan a operar.",
        what_need_to_do_point_three: "3. Tan pronto como su referido califique, ambos obtienen 25 USD cada uno.",
        referral_list: "Su lista de referidos"
    },
    referral_list: {
        referrals_list: "Lista de referencias",
        list_of_referrals: "Lista de referencias para realizar un seguimiento de sus ganancias.",
        s_no: "S.No.",
        name: "Nombre",
        email_id: "ID de correo electrónico",
        account_stage: "Etapa de la cuenta",
        deposits: "Depósitos",
        volume_required: "Volumen requerido",
        traded_volume: "Volumen negociado",
        qualified: "Calificado",
        no_data: "Sin datos",
        payment_of_referral_bonus: "El pago del Bono por Referencia se realizará en la semana posterior a la semana en la que el Referido haya calificado.",
        referral_bonus_paid_in_aaafx_wallet: "El Bono por Referencia se pagará en el monedero AAAFx USD, y tanto el Referente como el Referido podrán retirarlo o transferirlo a su cuenta de trading.",
        read_all_terms_conditions: "Lea todos los Términos y condiciones",
        here: "aquí",
        contact_us: "¿Tiene preguntas? Póngase en contacto con nosotros en Live Chat 24/5 o escríbanos a",
        customer_care: "customercare{'@'}aaafx-international.com",
        definitions: "Definiciones",
        meaning_of_all_above_columns: "A continuación se indica el significado de todas las columnas anteriores para su consulta:",
        name_of_your_referral: "- Nombre de su referido.",
        meaning_of_various_stages: "- Consulte a continuación el significado de las distintas etapas.",
        registered: "1. Registrado:",
        registered_link: "Su referido se registró usando su enlace.",
        funded: "2. Depositado:",
        referral_deposited: "Su referido hizo el depósito.",
        third_point_qualified: "3. Calificado:",
        referral_has_deposited: "Su referido depositó y alcanzó el volumen de operaciones requerido. Ahora ambos califican para la recompensa.",
        deposits_made_by_referral: "- Depósitos realizados por su referido.",
        volume_requirement: "Volumen requerido",
        volume_required_for_reward: "- El volumen requerido para que su referido pueda calificar para la recompensa.",
        volume_your_referral_traded: "- El volumen que su referido operó de forma efectiva.",
        referral_qualified_for_reward: "- Si su referido calificó para el requisito de recompensa o no todavía.",
        referral_ib_programs: "Tras obtener recompensas por 10 referidos, puede optar por convertirse en un IB o seguir en el Programa de referir y ganar con una recompensa de $20 tanto para usted como su referido. Puede comparar los beneficios y características de nuestros Programas de referir y ganar y de IB"
    },
    calculators_common: {
        asset_class: "Clase de Activos",
        forex: "Forex",
        commodities: "Commodities",
        indices: "Índices",
        account_base_currency: "Divisa base de la Cuenta",
        usd: "USD",
        gbp: "GBP",
        aud: "AUD",
        eur: "EUR",
        symbol: "Símbolo",
        select_symbol: "Seleccionar Símbolo",
        trade_size_in_lots: "Tamaño de la operación (en lotes)",
        calculate: "Calcular"
    },
    margin: {
        margin_required: "Margen requerido:",
        maximum_leverage: "Apalancamiento máximo:"
    },
    pip: {
        pip_value: "Valor del Pip:"
    },
    swap: {
        server: "Servidor",
        mt_four_five: "MT4/MT5",
        act_trader: "Act Trader",
        no_of_days: "Cantidad de días",
        long_swap: "Swap largo:",
        short_swap: "Swap corto:"
    },
    //S
    dashboard:{
        select_trading_id: "Seleccionar ID de trading",
        leverage: "Apalancamiento",
        balance: "Saldo",
        equity: "Capital",
        free_margin: "Sin margen",
        pnl: "PNL",
        web_trader : "Web Trader",
        fund: "Fondos",
        promotions: "Promociones",
        hundred: "100",
        bonus: "Bono",
        avail: "Disponible",
        deposit_bonus: "Bono de depósito",
        loading_initial_data: "Procesando datos iniciales",
    },
    enable_2fa:{
        title: "Autenticación de Google (2 factores)",
        description: "Para activar la autenticación de dos factores (2FA) de Google, escanee el código QR e introduzca la contraseña generada a continuación.",
        google_authenticator_code: "Código de Google Authenticator",
        how_to_enable: "Para activar la autenticación de 2 factores:",
        download: "Descargue la",
        google_authenticator_app: "App Google Authenticator",
        on_mobile_tablet: "en su dispositivo móvil o tablet.",
        scan_the : "Escanee el",
        qr_code: "código QR",
        appearing_above: "que aparece arriba",
        enter_the: "Ingrese el",
        passcode: "código de acceso único",
        appers_in_google_auth_app: "que aparece en su App Google Authenticator",
        click_on_the_button: "Haga clic en el botón",
        click_to_enable: "Haga clic para activar",
    },
    account_security:{
        title: "Autenticación de Google (2 factores)",
        description: "Para activar la autenticación de dos factores (2FA) de Google, escanee el código QR e introduzca la contraseña generada a continuación.",
        google_authenticator_code: "Código de Google Authenticator",
        how_to_enable: "Para activar la autenticación de 2 factores:",
        download: "Descargue la",
        google_authenticator_app: "App Google Authenticator",
        on_mobile_tablet: "en su dispositivo móvil o tablet.",
        scan_the : "Escanee el",
        qr_code: "código QR",
        appearing_above: "que aparece arriba",
        enter_the: "Ingrese el",
        passcode: "código de acceso único",
        appers_in_google_auth_app: "que aparece en su App Google Authenticator",
        click_on_the_button: "Haga clic en el botón",
        click_to_enable: "Haga clic para activar",
    },
    change_pass:{
        success_message:"Su contraseña se cambió con éxito.",
        ok:"OK",
        change_password: "Cambiar contraseña",
        existing_password: "Contraseña existente",
        new_password: "Nueva Contraseña",
        confirm_new_password: "Confirmar nueva contraseña",
        note_one: "La contraseña debe contener un mínimo de 7 y un máximo de 10 caracteres, y debe incluir al menos 1 número, 1 mayúscula y 1 carácter especial {'(!@#$%^)'}.",
        note_two: "Tenga en cuenta que la contraseña del perfil es distinta de la contraseña de su cuenta de trading.",
        cancel: "Cancelar",
    },
    corporate_varify_step_three:{
        please_upload_file: "suba el archivo",
        out_of_documents: "de un total de 8 Documentos",
        add_file: "Agregar archivo",
        max_file_size: "El tamaño máximo de los archivos que se pueden subir es de hasta"
    },
    corporate_varify:{
        corporation_info: 'Información de la empresa',
        account_creation: "Creación de Cuenta",
        verification: "Verificación",
        deposit: "Depósito",
        select_platform: "Seleccione plataforma",
        select_account_type: "Seleccione el tipo de cuenta",
        select_leverage: "Seleccione Apalancamiento",
        select_base_currency: "Seleccione la divisa base de la cuenta",
        select_currency: "Seleccione divisa",
        password: "Contraseña",
        pass_length_alert: "La longitud mínima de la contraseña es de 5 caracteres y debe contener al menos 1 letra minúscula, 1 letra mayúscula 1 número y 1 carácter especial.",
        of_characters: "de caracteres",
        lowercase_letter: 'Letra minúscula',
        capital_letter : "Letra mayúscula",
        number: "Número",
        special_character : "Carácter especial",
        confirm_password: "Confirmar contraseña",
        create_account : "Crear Cuenta",
    },
    corporation_info:{
        name_of_company: "Nombre de la empresa",
        country_of_company: "País de la empresa",
        select_company_country: "Seleccione el país de la empresa",
        registration: "Inscripción",
        submit: "ENVIAR",
    },
    profile:{
        personal_details: "Información personal",
        uploaded_documents: "Documentos subidos",
        no_documents_yet: "Sin documentos",
    },
    questions:{
        financial_details: "Información financiera",
        sub_heading_one: "Total de ingresos anuales estimados",
        select_annual_income: "Seleccionar ingresos anuales",
        sub_heading_two: "Valor neto total estimado",
        sub_heading_two_desc: "Activos totales menos pasivos totales de un particular o una empresa.",
        select_net_worth:"Seleccionar valor neto",
        sub_heading_three: "Sector de ocupación",
        select_occupation: "Seleccionar Ocupación",
        sub_heading_four: "Ingresar Otra ocupación",
        sub_heading_five: "Fuentes de los fondos",
        sub_heading_six: "Ingresar Otras fuentes de fondos",
        sub_heading_seven: "Persona objeto de obligación informativa en virtud de la ley FATCA de EE. UU.",
        sub_heading_eight: "País/Jurisdicción de residencia fiscal",
        select_residence_country: "Seleccionar país de residencia",
        sub_heading_nine: "¿Tiene Número de NIF?",
        sub_heading_ten: "Ingresar el número NIF",
        sub_heading_eleven: "Si no dispone de NIF, introduzca el motivo",
        select_reasons: "Seleccionar Motivos",
        enter_reason: "Ingresar Motivo",
        submit: "Enviar",
        dear: "Hola",
        message_one: "Según la información que se proporcionó, parece que usted es un residente de EE. UU. a efectos fiscales.",
        message_two: "Tenga en cuenta que debido a nuestro Cumplimiento Normativo, AAAFx no puede aceptar a un cliente que sea residente de EE. UU. a efectos fiscales.",
        message_three: "Le agradecemos de antemano su comprensión.",
        message_four: "Muy cordialmente,",
        message_five: "AAAFx",
        close: "Cerrar",
    },
    verify:{
        account_creation: "Creación de Cuenta",
        financial_details: "Información financiera",
        verification: "Verificación",
        deposit: "Depósito",
        select_platform: "Seleccione plataforma",
        select_account_type: "Seleccione el tipo de cuenta",
        select_leverage: "Seleccione Apalancamiento",
        select_base_currency: "Seleccione la divisa base de la cuenta",
        select_currency: "Seleccione divisa",
        password: "Contraseña",
        pass_message_one: "La longitud mínima de la contraseña es de 5 caracteres y debe contener al menos 1 letra minúscula, 1 letra mayúscula 1 número y 1 carácter especial.",
        pass_message_two: "La longitud mínima de la contraseña es de 8 caracteres y debe contener al menos 1 letra minúscula, 1 mayúscula, 1 número y 1 carácter especial.",
        of_characters: "de caracteres",
        lowercase_letter: "Letra minúscula",
        capital_letter: "Letra mayúscula",
        number: "Número",
        special_character: "Carácter especial",
        confirm_password: "Confirmar contraseña",
        create_account: "Crear Cuenta",
        doc_message_one: "Los documentos que presentó fueron rechazados por el proceso de verificación automática. Creamos un ticket al respecto en el que puede volver a subir sus documentos para que los verifiquemos manualmente si así lo desea.",
        view_ticket: "Ver Ticket",
    },
    verify_quest_bkp:{
        account_creation: "Creación de Cuenta",
        questionnaire: "cuestionario",
        verification: "Verificación",
        deposit:"Deposit",
        select_platform: "Seleccione plataforma",
        select_account_type: "Seleccione el tipo de cuenta",
        select_leverage: "Seleccione Apalancamiento",
        select_base_currency: "Seleccione la divisa base de la cuenta",
        select_currency: "Seleccione divisa",
        password: "Contraseña",
        pass_length_alert: "La longitud mínima de la contraseña es de 5 caracteres y debe contener al menos 1 letra minúscula, 1 letra mayúscula 1 número y 1 carácter especial.",
        of_characters: "de caracteres",
        lowercase_letter: "Letra minúscula",
        capital_letter: "Letra mayúscula",
        number: "Número",
        special_character: "Carácter especial",
        confirm_password: "Confirmar contraseña",
        create_account: "Crear Cuenta",
        doc_message_one: "Los documentos que presentó fueron rechazados por el proceso de verificación automática. Creamos un ticket al respecto en el que puede volver a subir sus documentos para que los verifiquemos manualmente si así lo desea.",
        view_ticket: "Ver Ticket",
    },
    close_ticket:{
        heading: "Tickets Cerrados",
        create_request: "CREAR SOLICITUD",
        open_tickets: "ABRIR TICKETS",
        ticket_number: "Número de Ticket",
        trading_id: "ID de trading",
        status: "Estado",
        subject: "Asunto",
        created: "Creado",
        closed: "Cerrado",
        action: "Acción",
        view_ticket: "Ver Ticket",
        no_tickets_found: "No se encontraron tickets",
    },
    open_ticket:{
        heading: "Entradas abiertas",
        create_request: "CREAR SOLICITUD",
        open_tickets: "ABRIR TICKETS",
        closed_ticket: "Tickets Cerrados",
        ticket_number: "Número de Ticket",
        trading_id: "ID de trading",
        status: "Estado",
        subject: "Asunto",
        created: "Creado",
        action: "Acción",
        view_ticket: "Ver Ticket",
        no_tickets_found: "No se encontraron tickets",
    },
    request_call:{
        success_message:"Su solicitud de llamada fue recibida. Nuestro equipo se pondrá en contacto en breve.",
        ok: "OK",
        request_call_back:"Solicitar llamada",
        first_name: "Nombre",
        last_name: "Apellido",
        email_id: "ID de correo electrónico",
        phone_number: "Número de teléfono",
        timezone: "Zona horaria",
        date: "Fecha",
        preferred_time: "Horario preferente",
        department: "Departamento",
        select_department: "Seleccionar departamento",
        new_accounts: "Cuentas nuevas",
        deposits: "Depósitos",
        withdrawals: "Retiros",
        partnership: "Alianzas",
        technical_support: "Soporte Técnico",
        message: "Mensaje",
        send_request: "Enviar Solicitud",
    },
    support_page:{
        success_message:"El ticket de soporte se creó con éxito. Puede darle seguimiento en la sección de Tickets abiertos.",
        ok:"OK",
        support: "Atención al cliente",
        create_req:"CREAR SOLICITUD",
        open_tickets:"TICKETS ABIERTOS",
        closed_tickets: "TICKETS CERRADOS",
        otp_msg:"Enviamos un OTP a su correo registrado. Ingréselo para verificar la solicitud del ticket de asistencia.",
        otp: "OTP",
        submit: "Enviar",
        reason: "Motivo",
        select_a_reason: "Seleccionar un motivo",
        trading_id: "ID de trading",
        select_trading_account: "Seleccionar Cuenta de Trading",
        subject: "Asunto",
        trade_order_id: "ID de la orden de operación",
        time_of_trade_opening: "Hora de apertura de la operación",
        time_of_trade_closing: "Hora de cierre de la operación",
        instrument_traded: "Instrumento negociado",
        type_of_trade: "Tipo de operación",
        select_trade_type: "Seleccionar tipo de operación",
        details_of_the_issue: "Detalles del incidente",
        refund_claim_amount: "Importe de la solicitud de reembolso",
        message: "Mensaje",
        note: "NOTA",
        file_attachments: "Archivos adjuntos",
        file_size_msg: "El tamaño del documento no debe ser superior a 1MB",
        file_format_msg: "Solo formato de archivo (JPEG o PDF)",
        lowercase_note: "Nota",
        note_desc: "En caso de que se produzca algún error al realizar alguna operación en la cuenta, adjunte también la captura de pantalla al crear el ticket",
        create_support_request: "Crear una solicitud de asistencia",
    },
    become_ib:{
        heading: "Bróker Introductorio",
        description: "Aumente sus ganancias con nuestro Programa IB. <br /> Obtenga su enlace dedicado, compártalo con sus amigos y gane comisiones cada vez que operen.",
        sub_heading: "Ofrecemos dos categorías de programas IB:",
        point_one: "Programa IB Estándar: Obtenga directamente el 20 % de nuestras ganancias por comisiones de sus clientes. Esto es útil para un IB principiante que quiere empezar de cero o puede empezar a traer un volumen limitado de clientes.",
        point_two: "Programa IB Avanzado: Este es un programa IB altamente remunerativo y personalizado para nuestros IB más grandes. Esto es útil para alguien con una base de clientes importante que puede aportar un mayor volumen.",
        note_one: "Podrá pasar del Programa IB Estándar al Programa IB Avanzado, una vez que haya ampliado su red lo suficiente.",
        earn_with: "Gane sin",
        zero_investment_or: "inversión ni",
        experience: "experiencia",
        weekly_ib: "Pagos",
        commissions: "semanales de",
        payouts: "comisiones IB",
        unlimited: "Posibilidad",
        earnings: "de ganancias",
        potential: "ilimitadas",
        sub_cont_point_four: "Programa IB avanzado altamente personalizado y provechoso",
        ultra_fast: "Retiros",
        withdrawals_of_ib: "ultrarrápidos",
        commission: "de comisiones",
        easy_user: "de IB",
        interface_of: "Interfaz de ",
        ib_portal: "usuario sencilla",
        dedicated: "Portal de IB",
        account: "Gestor de",
        manager: "Cuenta Exclusivo",
        helpful_and: "Material",
        free_marketing: "de marketing",
        material: "útil y gratuito",
        become_an_ib: "Conviértase en IB",
    },
    pamm_acct:{
        title:"CUENTA PAMM",
        description_one: "PAMM (Percentage Allocation Management Module) es una cuenta de gestión en la que el gestor ejecuta operaciones en todas sus subcuentas. El gestor y los inversores son libres de elegir una estructura de comisiones de rentabilidad, y nosotros nos encargamos de ponerla en práctica.",
        description_two: "AAAFx ofrece soluciones de trading PAMM altamente flexibles y personalizadas.",
        sub_title: "Cómo inscribirse como gestor PAMM",
        sub_Point_one: "Su cuenta de Gestor PAMM se puede abrir una vez que tenga por lo menos cuatro inversionistas con un depósito total de 5 000 USD o más.",
        sub_Point_two: "Solo regístrese como IB para convertirse en gestor PAMM con nosotros. Los clientes deben registrarse utilizando su enlace IB y cumplir la primera condición anterior.",
        sub_Point_three: "Póngase en contacto con nosotros a través de Live Chat o envíenos un correo electrónico a",
        sub_Point_four: "Comience a ganar comisiones IB además de las Comisiones de Rendimiento PAMM.",
        minimul_investment: "INVERSIÓN MÍNIMA",
        ease_of_access: "FÁCIL ACCESO",
        ultimate_trading_conditions: "CONDICIONES DE TRADING DE VANGUARDIA",
        trade_security: "SEGURIDAD AL OPERAR",
        request_pamm: "Solicitar PAMM",
    },
    add_payment_methods:{
        success_message: "Su método de pago se agregó correctamente. Puede hacer un seguimiento en Tickets abiertos.",
        ok: "OK",
        otp_message: "Le enviamos una OTP a su correo electrónico registrado. Introdúzcala para verificar la solicitud de ticket de asistencia.",
        otp: "OTP",
        submit: "Enviar",
        page_heading: "Agregar métodos de pago",
        select_payment_method: "Seleccionar método de pago",
        select_method: "Seleccionar método",
        bank: "Banco",
        credit_card: "Tarjeta de Crédito",
        crypto: "Cripto",
        select_crypto_currency: "Seleccionar criptomoneda",
        select_crypto: "Seleccionar Cripto",
        btc: "BTC",
        eth: "ETH",
        usdt: "USDT",
        usdc: "USDC",
        add_your_bank_details: "Introducir sus datos bancarios",
        bank_name: "Nombre del banco",
        account_name: "Nombre de la cuenta",
        account_number: "Número de cuenta",
        country: "País",
        select_country: "Seleccionar país",
        iban: "IBAN",
        iban_note: "Mi banco no emite IBAN",
        swift: "Swift",
        bic: "BIC",
        sort_code: "Código Sort",
        bank_address: "Dirección del banco",
        upload_your_bank_statement: "Suba su estado de cuenta",
        upload_doc_info_one: "El tamaño del documento no debe ser superior a 1MB",
        upload_doc_info_two: "Solo formato de archivo (JPEG o PDF)",
        note: "Nota",
        note_msg: "En caso de que se produzca algún error al realizar alguna operación en la cuenta, adjunte también la captura de pantalla al crear el ticket",
        create_support_request: 'Crear solicitud de asistencia',
        add_your_card_details: "Agregue los datos de su tarjeta",
        creadit_card_number: "Número de tarjeta de crédito",
        month: "Mes",
        zero_one: "01",
        zero_two: "02",
        zero_three: "03",
        zero_four: "04",
        zero_five: "05",
        zero_six: "06",
        zero_seven: "07",
        zero_eight: "08",
        zero_nine: "09",
        ten: "10",
        eleven: "11",
        twelve: "12",
        year: "Año",
        two_thousand_twenty: "2020",
        two_thousand_twentyone: "2021",
        two_thousand_twentytwo: "2022",
        two_thousand_twentytree: "2023",
        two_thousand_twentyfour: "2024",
        two_thousand_twentyfive: "2025",
        two_thousand_twentysix: "2026",
        two_thousand_twentyseven: "2027",
        two_thousand_twentyeight: "2028",
        two_thousand_twentynine: "2029",
        two_thousand_thirty: "2030",
        cvv: "CVV",
        varification_msg: "Para la verificación de la tarjeta necesitamos lo siguiente",
        varification_msg_one: "Copia en color del anverso de la tarjeta, que muestre: nombre completo, fecha de caducidad, nombre/logotipo del banco, 4 primeros y 4 últimos dígitos del número de la tarjeta de crédito que oculten los 8 dígitos centrales.",
        upload_supporting_document: "Subir documento de respaldo",
        varification_msg_two: "Copia en color del reverso de la tarjeta que oculta el código de seguridad CVV. En el reverso debe figurar la firma del titular",
        add_selected_crypto_address: "Agregar dirección cripto seleccionada",
        address: "Dirección",
    },
    deposit:{
        account_type: "Tipo de cuenta",
        select_type: "Seleccionar tipo",
        live: "En vivo",
        trading_account: "Cuenta de trading",
        select_trading_account: "Seleccionar Cuenta de Trading",
        balance: "Saldo",
        fund: "FONDO",
        amount: "Monto",
        region: "Región",
        currencies: "Divisas",
        processing_time: "Tiempo de Procesamiento",
        action: "Acción",
        view_more: "Ver más",
        currency: "Divisa",
        zar: "ZAR",
        swift_code: "Código Swift",
        beneficiarys_name: "Nombre de los beneficiarios",
        beneficiarys_name_des: "SIKHULA VENTURE CAPITAL (PTY) LTD",
        account_number: "Número de cuenta",
        user_account_number: "62928423269",
        bank_address: "Dirección del banco",
        bank_address_info: "Mybranch Forum 1, 4th Fl, 33 Hoofd Str, Braampark",
        dixipay: "Dixipay",
        bank_name: "Nombre del banco",
        bank_name_info: "DIXIPAY LTD",
        swift_code_info: "DIXPGB21",
        beneficiarys_name_info: 'Alpha Global Limited',
        iban: "IBAN",
        iban_no: "GB78DIXP00997890200462",
        eur: "EUR",
        city: "Ciudad",
        city_info: "Londres",
        country: "País",
        country_info: "Reino Unido",
        dixipay_note: "Dixipay solo acepta depósitos en EUROS",
        you_can_deposit: "Puede depositar",
        you_can_deposit_msg: "en la siguiente dirección y se añadirá el importe equivalente en la divisa de la cuenta seleccionada tras la conversión",
        copy: "Copiar",
        done: "Listo",
        network_msg: "La red ERC-20 (USDT, USDC, ETH) es compatible. El uso de cualquier otra red no llegará a nuestro alcance.",
    },
    fund_index: {
        add_funds: "Agregar fondos",
        cancel: "Cancelar",
        ok: "OK",
        your_request_to_add: "Su solicitud para agregar",
        to_your_demo_account_number: "a su número de Cuenta Demo",
        has_been_successfully_completed: "se completó con éxito",
        your_request_to_withdraw: "Su solicitud de retiro",
        from_the_trading_id: "desde el ID de trading",
        has_been_received: "ha sido recibida",
        click_to_proceed_withdrawal: "Haga clic en el enlace de confirmación enviado a su dirección de correo electrónico registrada para procesar el retiro",
        has_been_successfully: "se completó con éxito",
        your_request_to_add_usd: "Su solicitud para agregar USD",
    },
    request_verify: {
        verifying_your_request: "Verificando su solicitud",
        success: "ÉXITO",
        go_to_transactions: "Ir a Transacciones",
        error: "ERROR",
    },
    transactions: {
        list_of_transactions: "Lista de Transacciones",
        deposits: "Depósitos",
        withdrawals: "Retiros",
        bonus: "Bono",
        deposit_transactions: "Transacciones de depósito",
        filter_by: "Filtrar por",
        select_trading_id: "Seleccionar ID de trading",
        all: "TODO",
        date: "Fecha",
        account_id: 'ID de la cuenta',
        currency: "Divisa",
        payment_mode: "Forma de pago",
        deposit_amount: "Monto del Depósito",
        status: 'Estado',
        no_deposits_yet: "Aún no hay depósitos",
        withdrawal_mode: "Forma de retiro",
        withdrawal_amount: "Monto de retiro",
        action: "Acción",
        view_more : "Ver más",
        no_withdrawals_yet: "Aún no hay retiros",
        bonus_amount: "Monto del bono",
        pending : "Pendiente",
        no_bonus_transactions_yet: "Aún no hay transacciones de bonos",
        deposit_currency: "Divisa del depósito",
        account_currency: 'Divisa de la cuenta',
        address: 'Dirección',
    },
    withdrawal: {
        kyc_req_msg: "Es obligatorio completar el KYC antes de solicitar un retiro. Envíe un comprobante de domicilio mediante un ticket de asistencia",
        Click_here: "Haga clic aquí",
        or_email_to: 'o enviar un correo electrónico a',
        with_step_heading: "Se aceptan los siguientes comprobantes de domicilio",
        one: "1",
        two: "2",
        three: "3",
        with_step_one: "Factura de servicios públicos",
        with_step_two: "Estado de cuenta",
        with_step_three: "Documento fiscal emitido por el Gobierno",
        note: "Nota",
        note_info: "Se requiere que el comprobante de domicilio tenga una antigüedad no mayor a 4 meses",
        ok: "OK",
        enable_2fa_msg: "Es obligatorio activar la autenticación de dos factores para solicitar el retiro de fondos. Haga clic en el siguiente botón",
        click_to_enable: "Haga clic para activar",
        select_trading_id: "Seleccionar ID de trading",
        account_id: "ID de cuenta",
        account_type: "Tipo de cuenta",
        platform: 'Platform',
        leverage: "Apalancamiento",
        currency: "Divisa",
        free_margin: "Sin margen",
        note_info_two: "Introduzca el importe del retiro en la divisa base de su cuenta de trading.",
        amount: "Monto",
        mode_of_payment: "Forma de pago",
        create_transaction: "Crear transacción",
        cancel: "Cancelar",
        add_payment_method: "Agregar método de pago",
        no_amount_available: "No hay ningún monto disponible en esta cuenta",
    },
    //components -> Shared
    account_dropdown:{
        select_account: "Seleccionar cuenta",
    },
    footer: {
        legal_information: "Información Legal",
        legal_information_info: "Sikhula Venture Capital (Pty) Ltd. está autorizada y regulada por la Autoridad de Conducta del Sector Financiero de Sudáfrica (FSCA n.° 2017/315029/07).",
        risk_warning: "Advertencia sobre riesgos",
        risk_warning_info: `Operar con divisas al contado implica un riesgo considerable y siempre existe la posibilidad de sufrir pérdidas. Sus resultados de trading pueden variar. Dado que el factor de riesgo es elevado en las operaciones en el mercado de divisas, en este tipo de operaciones solo deben utilizarse auténticos fondos de "riesgo". Si no dispone de un capital adicional que pueda permitirse perder, no debería operar en el mercado de divisas. Nunca se ha concebido un sistema de operaciones "seguro", y nadie puede garantizar las ganancias o la ausencia de pérdidas.`,
    },
    header: {
        welcome: "Bienvenido", 
        profile: 'Profile',
        request_callback: "Solicitar devolución de llamada",
        support_ticket: "Ticket de asistencia",
        change_password: "Cambiar contraseña",
        logout: "Cerrar sesión",
    },
    pagination: {
        total_records: "Total de registros", 
    },
    side_bar: {
        dashboard: "Panel de control",
        manage_accounts: "Gestionar cuentas",
        fund: "Fondos",
        bonus: "Bono",
        become_a_partner: "Conviértase en socio",
        tools: "Herramientas",
        bonus_and_promotions: 'Bonos y promociones',
    },
    success_box: {
        otp_varify: "Introduzca el PIN de un solo uso de 6 dígitos que se muestra en la App Google Authenticator.",
        cancel: "Cancelar",
        submit: 'Submit',
        trouble_with_2fa: "¿Tiene problemas con su código de autenticación de dos factores?",
        click_varify_with_email: "Haga clic aquí para verificar con correo electrónico",
        or: "O",
        click_here: "Haga clic aquí",
        to_enable_2fa: "para activar su autentificación en dos factores y completar su solicitud",
        take_me_back: "Regresar",
    },
    tost_message: {
        varify_acc: "Verifique su cuenta para crear una cuenta real",
        click_to_begin: "Haga clic para iniciar el proceso de verificación",
    },
    proof_residence_alert: {
        you_have: "Le quedan",
        days_left_for_proof: "días para enviar el comprobante de residencia.",
        click_here: "Haga clic aquí",
        to_upload: "para subir",
    },
    closed_trades: {
        login: "Iniciar sesión",
        order: "Orden",
        symbol: "Símbolo",
        volume: "Volumen",
        open_price: "Precio de apertura",
        open_time: "Hora de apertura",
        commission: "Comisión",
        type: 'Tipo',
        sl: "SL",
        tp: "TP",
        close_price: 'Precio de cierre',
        close_time: 'Hora de cierre',
        swap: 'Swap',
        pnl: "PNL",
        comment: 'Comentario',
        no_record_found: "No se encontró ningún registro",
    },
    open_trade: {
        order: 'Orden',
        symbol: 'Símbolo',
        type: 'Tipo',
        volume: "Volumen",
        open_price: "Precio de apertura",
        pnl: "PNL",
        no_record_found: "No se encontró ningún registro",
    },
}